import { IsString } from 'class-validator';

export class NomenclatureTypeDeleteRequest {
    @IsString()
    public uuid: string;

    constructor(data?: Partial<NomenclatureTypeDeleteRequest>) {
        this.uuid = data?.uuid;
    }
}
